export const CANCELLED = "CANCELLED";
export const DONE = "DONE";
export const ERROR = "ERROR";
export const IN_PROGRESS = "IN_PROGRESS";
export const UPDATE_IN_PROGRESS = "UPDATE_IN_PROGRESS";
export const REQUIRE_PRICE_CONFIRMATION = "REQUIRE_PRICE_CONFIRMATION";
export const NEW_PRICE_ACCEPTED = "NEW_PRICE_ACCEPTED";
export const UPDATE_ERROR = "UPDATE_ERROR";
